<template>
    <v-layout column mb-4>
        <v-tabs
            color="white"
            slider-color="#e2173d"
            :value="selected_filter_index"
            class="tabs-mobile"
            :class="{
                'mb-4': $vuetify.breakpoint.smAndDown,
                'mb-5': $vuetify.breakpoint.mdAndUp,
            }"
        >
            <v-tab
                v-for="(filter, idx) in filters"
                :key="filter.name"
                class="wrapper-relative"
                @click="SELECT_FILTER(idx)"
            >
                <v-layout row wrap align-center>
                    <v-flex md2>
                        <svg v-svg
                             :symbol="filter.image"
                             size="32 32"
                             class="icon"
                             role="presentation"
                        />
                    </v-flex>
                    <v-flex sm12 xs12 md9
                            :class="{'pl-0': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                    >{{ $t(filter.text) }}</v-flex>
                    <v-flex class="md1 study__badge">
                        <v-badge :color="filter.color">
                            <span slot="badge">{{ courses_number[filter.name] || 0 }}</span>
                        </v-badge>
                    </v-flex>
                </v-layout>
            </v-tab>
        </v-tabs>
        <h2 v-if="selected_filter && $vuetify.breakpoint.mdAndUp" class="section-title mt-3 ml-0">{{ $t(selected_filter.text) }}</h2>
        <template v-if="course_lists[selected_filter.name].length > 0">
            <div
                v-for="(course) in course_lists[selected_filter.name]"
                :id="'id'+course.id"
                :key="course.id"
            >
                <KnowledgeCheckCard :card="course" :filter="selected_filter" :course-type="selected_filter.name" />
            </div>
        </template>
        <div v-else>{{ $t("По запросу ничего не найдено") }}</div>
    </v-layout>
</template>

<script>
import KnowledgeCheckCard from '@/components/view_blocks/Knowledge_check/Knowledge_check_card.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name      : 'KnowledgeCheckCards',
  components: {
    KnowledgeCheckCard,
  },
  computed: {
    ...mapGetters('knowledge_check', ['course_lists', 'filters', 'selected_filter', 'courses_number', 'selected_filter_index']),
  },
  async mounted() {
    await this.get_courses();
  },
  methods: {
    ...mapMutations('knowledge_check', ['SELECT_FILTER']),
    ...mapActions('knowledge_check', ['get_courses']),
  },
};
</script>
